import { AuthenticateConsumerAction } from '../../actions/consumerDataPullSessionActions/consumerAuthenticationActions'
import { BankError } from '#modules/Bank/Bank.types'

export enum ConsumerAuthenticationStatus {
	IDLE = 'idle',
	AUTHENTICATE_SUCCESS = 'authenticateSuccess',
	AUTHENTICATE_FAILURE = 'authenticateFailure',
	AUTHENTICATING = 'authenticating',
}

export interface ConsumerAuthenticationState {
	applicantSessionFinishedOn: Date | null
	status: ConsumerAuthenticationStatus
	error?: BankError
	sessionId: string | null
}

const INITIAL_STATE: ConsumerAuthenticationState = {
	status: ConsumerAuthenticationStatus.IDLE,
	sessionId: null,
	applicantSessionFinishedOn: null,
}

export function authenticatingSessionReducer(
	state: ConsumerAuthenticationState,
	action: AuthenticateConsumerAction,
): ConsumerAuthenticationState {
	switch (action.type) {
		case 'transactionClientApp/authenticate/succeeded':
			return {
				...state,
				status: ConsumerAuthenticationStatus.AUTHENTICATE_SUCCESS,
				sessionId: action.payload.sessionId,
				applicantSessionFinishedOn: action.payload.authenticateDto.finishedOn,
			}
		case 'transactionClientApp/authenticate/failed':
			return {
				...state,
				status: ConsumerAuthenticationStatus.AUTHENTICATE_FAILURE,
				error: action.payload,
			}
		default:
			return state
	}
}

export function authenticateSuccessSessionReducer(
	state: ConsumerAuthenticationState,
	action: AuthenticateConsumerAction,
): ConsumerAuthenticationState {
	switch (action.type) {
		case 'transactionClientApp/authenticate/withSessionId':
			return {
				...state,
				status: ConsumerAuthenticationStatus.AUTHENTICATING,
				sessionId: action.payload.sessionId,
			}
		default:
			return state
	}
}

export function authenticateFailureSessionReducer(
	state: ConsumerAuthenticationState,
	action: AuthenticateConsumerAction,
): ConsumerAuthenticationState {
	switch (action.type) {
		case 'transactionClientApp/authenticate/withSessionId':
			return {
				...state,
				status: ConsumerAuthenticationStatus.AUTHENTICATING,
				sessionId: action.payload.sessionId,
			}
		default:
			return state
	}
}

export function idleSessionReducer(
	state: ConsumerAuthenticationState,
	action: AuthenticateConsumerAction,
): ConsumerAuthenticationState {
	switch (action.type) {
		case 'transactionClientApp/authenticate/withSessionId':
			return {
				...state,
				status: ConsumerAuthenticationStatus.AUTHENTICATING,
				sessionId: action.payload.sessionId,
			}
		default:
			return state
	}
}

export default function reduce(
	state: ConsumerAuthenticationState = INITIAL_STATE,
	action: AuthenticateConsumerAction,
): ConsumerAuthenticationState {
	switch (state.status) {
		case ConsumerAuthenticationStatus.IDLE:
			return idleSessionReducer(state, action)
		case ConsumerAuthenticationStatus.AUTHENTICATING:
			return authenticatingSessionReducer(state, action)
		case ConsumerAuthenticationStatus.AUTHENTICATE_SUCCESS:
			return authenticateSuccessSessionReducer(state, action)
		case ConsumerAuthenticationStatus.AUTHENTICATE_FAILURE:
			return authenticateFailureSessionReducer(state, action)
		default:
			//	TODO log as error
			return state
	}
}
